import { render, staticRenderFns } from "./wenti.vue?vue&type=template&id=01f98e56&scoped=true&"
import script from "./wenti.vue?vue&type=script&lang=js&"
export * from "./wenti.vue?vue&type=script&lang=js&"
import style0 from "./wenti.vue?vue&type=style&index=0&id=01f98e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f98e56",
  null
  
)

export default component.exports